export const sponsors = [
  {
    name: "Vishnu Pandey",
    role: "Founder & CEO",
    experience: "6 Year Experience",
    image: "../assets/images/sponser2.jpg",
    socialLinks: {
      // pinterest: "",
      instagram: "",
      linkedin: "",
      close: "",
      facebook: "",
    },
  },
  {
    name: "Shivam Rathore",
    role: "Chief Management Officer - CMO",
    experience: "5 Year Experience",
    image: "../assets/images/Shivam.jpeg",
    socialLinks: {
      // pinterest: "",
      instagram: "",
      linkedin: "",
      close: "",
      facebook: "",
    },
  },
  {
    name: "Murli Manohar Soni",
    role: "Sr. Software Developer",
    experience: "8 Year Experience",
    image: "../assets/images/sponser1.jpg",
    socialLinks: {
      // pinterest: "/",
      instagram: "/",
      linkedin: "/",
      close: "/",
      facebook: "/",
    },
  },

  {
    name: "Lucky Kumawat",
    role: "Full Stack Developer",
    experience: "3 Year Experience",
    image: "../assets/images/sponser3.jpg",
    socialLinks: {
      // pinterest: "/",
      instagram: "/",
      linkedin: "/",
      close: "/",
      facebook: "/",
    },
  },
  {
    name: "Neha Verma",
    role: "Full Stack Developer",
    experience: "4 Year Experience",
    image: "../assets/images/sponser4.jpg",
    socialLinks: {
      // pinterest: "/",
      instagram: "/",
      linkedin: "/",
      close: "/",
      facebook: "/",
    },
  },
  {
    name: "Bhawna Keshwani",
    role: "Back-end Developer",
    experience: "2 Year Experience",
    image: "../assets/images/sponser5.jpg",
    socialLinks: {
      // pinterest: "/",
      instagram: "/",
      linkedin: "/",
      close: "/",
      facebook: "/",
    },
  },
  {
    name: "Laveena Keshwani",
    role: "Multi Media / Content Creator",
    experience: "2 Year Experience",
    image: "../assets/images/Laveena.jpg",
    socialLinks: {
      // pinterest: "/",
      instagram: "/",
      linkedin: "/",
      close: "/",
      facebook: "/",
    },
  },
];

export const photos = [
  {
    image: "../assets/photos/saryu 61.jpg",
  },
  {
    image: "../assets/photos/saryu 62.jpg",
  },
  {
    image: "../assets/photos/saryu 63.jpg",
  },
  {
    image: "../assets/photos/saryu 64.jpg",
  },
  {
    image: "../assets/photos/saryu 65.jpg",
  },
  {
    image: "../assets/photos/saryu 66.jpg",
  },
  {
    image: "../assets/photos/saryu 67.jpg",
  },
  {
    image: "../assets/photos/saryu 68.jpg",
  },
  {
    image: "../assets/photos/saryu 69.jpg",
  },
  {
    image: "../assets/photos/saryu 70.jpg",
  },
  {
    image: "../assets/photos/saryu 1.jpg",
  },
  {
    image: "../assets/photos/saryu 2.jpg",
  },

  {
    image: "../assets/photos/saryu 3.jpg",
  },
  {
    image: "../assets/photos/saryu 4.jpg",
  },
  {
    image: "../assets/photos/saryu 5.jpg",
  },
  {
    image: "../assets/photos/saryu 6.jpg",
  },
  {
    image: "../assets/photos/saryu 7.jpg",
  },
  {
    image: "../assets/photos/saryu 8.jpg",
  },
  {
    image: "../assets/photos/saryu 9.jpg",
  },
  {
    image: "../assets/photos/saryu 10.jpg",
  },
  {
    image: "../assets/photos/saryu 11.jpg",
  },
  {
    image: "../assets/photos/saryu 12.jpg",
  },
  {
    image: "../assets/photos/saryu 13.jpg",
  },
  {
    image: "../assets/photos/saryu 14.jpg",
  },
  {
    image: "../assets/photos/saryu 15.jpg",
  },
  {
    image: "../assets/photos/saryu 16.jpg",
  },
  {
    image: "../assets/photos/saryu 17.jpg",
  },
  {
    image: "../assets/photos/saryu 18.jpg",
  },
  {
    image: "../assets/photos/saryu 19.jpg",
  },
  {
    image: "../assets/photos/saryu 20.jpg",
  },
  {
    image: "../assets/photos/saryu 21.jpg",
  },
  {
    image: "../assets/photos/saryu 22.jpg",
  },
  {
    image: "../assets/photos/saryu 23.jpg",
  },
  {
    image: "../assets/photos/saryu 24.jpg",
  },
  {
    image: "../assets/photos/saryu 25.jpg",
  },
  {
    image: "../assets/photos/saryu 26.jpg",
  },
  {
    image: "../assets/photos/saryu 27.jpg",
  },
  {
    image: "../assets/photos/saryu 28.jpg",
  },
  {
    image: "../assets/photos/saryu 29.jpg",
  },
  {
    image: "../assets/photos/saryu 30.jpg",
  },
  {
    image: "../assets/photos/saryu 31.jpg",
  },
  {
    image: "../assets/photos/saryu 32.jpg",
  },
  {
    image: "../assets/photos/saryu 33.jpg",
  },
  {
    image: "../assets/photos/saryu 34.jpg",
  },
  {
    image: "../assets/photos/saryu 35.jpg",
  },
  {
    image: "../assets/photos/saryu 36.jpg",
  },
  {
    image: "../assets/photos/saryu 37.jpg",
  },
  {
    image: "../assets/photos/saryu 38.jpg",
  },
  {
    image: "../assets/photos/saryu 39.jpg",
  },
  {
    image: "../assets/photos/saryu 40.jpg",
  },
  {
    image: "../assets/photos/saryu 41.jpg",
  },
  {
    image: "../assets/photos/saryu 42.jpg",
  },
  {
    image: "../assets/photos/saryu 43.jpg",
  },
  {
    image: "../assets/photos/saryu 44.jpg",
  },
  {
    image: "../assets/photos/saryu 45.jpg",
  },
  {
    image: "../assets/photos/saryu 46.jpg",
  },
  {
    image: "../assets/photos/saryu 47.jpg",
  },
  {
    image: "../assets/photos/saryu 48.jpg",
  },
  {
    image: "../assets/photos/saryu 49.jpg",
  },
  {
    image: "../assets/photos/saryu 50.jpg",
  },
  {
    image: "../assets/photos/saryu 51.jpg",
  },
  {
    image: "../assets/photos/saryu 52.jpg",
  },
  {
    image: "../assets/photos/saryu 53.jpg",
  },
  {
    image: "../assets/photos/saryu 54.jpg",
  },
  {
    image: "../assets/photos/saryu 55.jpg",
  },
  {
    image: "../assets/photos/saryu 56.jpg",
  },
  {
    image: "../assets/photos/saryu 57.jpg",
  },
  {
    image: "../assets/photos/saryu 58.jpg",
  },
  {
    image: "../assets/photos/saryu 59.jpg",
  },
  {
    image: "../assets/photos/saryu 60.jpg",
  },
];

// src/constants/menuConstants.js

export const navigationMenu = [
  { name: "Dashboard", path: "/dashboard" },
  { name: "Member Manager", path: "/member-manager" },
  { name: "Payment Manager", path: "/payment-manager" },
  { name: "Team Manager", path: "/team-manager" },
  { name: "Event Manager", path: "/event-manager" },
  { name: "Matrimonial Manager", path: "/matrimonial-manager" },
  { name: "Suvichar Manager", path: "/suvichar-manager" },
  { name: "Job Manager", path: "/employment-manager" },
  { name: "Contact Us Manager", path: "/contect-us-manager" },
  { name: "Suggestion Manager", path: "/suggestion-manager" },
];
export const navigationSideMenu = [
  { name: "Samaj Member's", path: "/member-info" },
  { name: "Matrimonial's", path: "/matrimonial-post" },
  { name: "Suvichar Posts", path: "/suvichar-post" },
  { name: "Employment Posts", path: "/employment-post" },
];
